import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "serial-settings-view" }
const _hoisted_2 = { class: "font-weight-medium" }
const _hoisted_3 = { class: "font-weight-medium" }
const _hoisted_4 = { class: "font-weight-medium" }

import { ref, onMounted, computed } from 'vue'
import { useSerialSettingsStore } from './store'
import { SerialSettings } from './models/serialSettings'


export default /*@__PURE__*/_defineComponent({
  __name: 'SerialSettingsView',
  setup(__props) {

const serialSettingsStore = useSerialSettingsStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Puerto', key: 'port' },
  { title: 'Baud Rate', key: 'baudRate' },
  { title: 'Bits de Datos', key: 'dataBits' },
  { title: 'Bits de Parada', key: 'stopBits' },
  { title: 'Paridad', key: 'parity' },
  { title: 'Timeout', key: 'timeoutMs' },
  { title: 'Delimitador', key: 'delimiter' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const serialSettingsList = computed(() => serialSettingsStore.serialSettings)

const getDisplayDelimiter = (delimiter: string) => {
  // Función para mostrar delimitadores especiales de forma legible
  switch (delimiter) {
    case '\n':
      return '\\n'
    case '\r':
      return '\\r'
    case '\r\n':
      return '\\r\\n'
    case '\t':
      return '\\t'
    case ' ':
      return 'SPACE'
    default:
      return delimiter || 'Sin delimitador'
  }
}

const refreshData = async () => {
  loading.value = true
  try {
    await serialSettingsStore.getSerialSettings()
  } finally {
    loading.value = false
  }
}

const addItem = () => {
  // Implementar lógica para agregar configuración serial
  console.log('Add new serial settings')
}

const editItem = (item: SerialSettings) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: SerialSettings) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("h1", null, "Configuración Serial", -1),
                _createElementVNode("p", null, "Gestión de configuraciones seriales del sistema", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: serialSettingsList.value,
                  loading: loading.value,
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("Lista de Configuraciones Seriales")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[3] || (_cache[3] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "success",
                          class: "ml-2",
                          onClick: addItem
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1
                            }),
                            _cache[5] || (_cache[5] = _createTextVNode(" Agregar Configuración "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.port": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "blue",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.port), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.baudRate": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "green",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.baudRate), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.parity": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "purple",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.parity), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.dataBits": _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(item.dataBits), 1)
                  ]),
                  "item.stopBits": _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.stopBits), 1)
                  ]),
                  "item.timeoutMs": _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(item.timeoutMs) + " ms", 1)
                  ]),
                  "item.delimiter": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "orange",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getDisplayDelimiter(item.delimiter)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: "mr-2",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" mdi-pencil ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      small: "",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" mdi-delete ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})